import { StreamJsonModel, StreamSchema } from '../../domain/stream/stream/StreamDomain';
import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { StreamActions } from '../actions/StreamActions';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';

export interface StreamState {
  stream: StreamJsonModel;
  streamSchema: DeploymentModel<StreamSchema> | null;
  isUpdate: boolean;
  dependencies: ComponentDependency[];
  isDirty: boolean;
}

const initialState: StreamState = {
  stream: ValueFactory.initializeStream(),
  streamSchema: { stage: 'DRAFT' } as DeploymentModel<StreamSchema>,
  isUpdate: false,
  dependencies: [],
  isDirty: false,
};

export const streamReducer = (state = initialState, action: ReduxBaseAction<any, StreamActions>): StreamState => {
  switch (action.type) {
    case 'CHANGE_STREAM':
      return { ...state, stream: action.payload, isDirty: true };
    case 'CHANGE_STREAM_SCHEMA':
      return { ...state, streamSchema: action.payload };
    case 'CHANGE_STREAM_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_STREAM':
      return { ...state, stream: ValueFactory.initializeStream(), isUpdate: false, streamSchema: null, dependencies: [], isDirty: false };
    case 'CHANGE_STREAM_DEPENDENCIES':
      return { ...state, dependencies: action.payload };
    case 'CHANGE_STREAM_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
